import type {
  MetricsBlock,
  DirectorBlock,
  StatsBlock,
  CampusBlock,
  ProgramLocationsList,
  ProgramDescriptionBlock,
  ProgramContentBlock,
  SeoSiblingsBlock,
} from '~/types/school'

// ── Fallbacks réutilisables ────────────────────────────────
export const EMPTY_SEO_BLOCK: SeoSiblingsBlock = { Title: '', Links: [] }

export const EMPTY_METRICS_BLOCK: MetricsBlock = { Title: '', Metrics: [] }

export const EMPTY_DIRECTOR_BLOCK: DirectorBlock = {
  Title: '',
  FirstName: '',
  LastName: '',
  Content: '',
  PictUrl: '',
  LinkedInLink: '',
}

export const EMPTY_STATS_BLOCK: StatsBlock = {
  Employment: {
    Title: '',
    SubTitle: '',
    EmploymentRate: 0,
    SalMinFR: '',
    SalMaxFR: '',
    SalMinWithPFR: '',
    SalMaxWithPFR: '',
    SalMinAB: '',
    SalMaxAB: '',
    SalMinWithPAB: '',
    SalMaxWithPAB: '',
  },
  Stats: [],
}

export const EMPTY_CAMPUS_BLOCK: CampusBlock = { Title: '', Campuses: [] }

export const EMPTY_PROGRAMS_LOCATIONS_LIST: ProgramLocationsList = { Title: '', Items: [] }

export const EMPTY_PROGRAM_DESCRIPTION_BLOCK: ProgramDescriptionBlock = {
  Title: '',
  DegreeBlock: { Title: '', Links: [] },
  FormatStyle: { Title: '', Items: [] },
  Duration: { Title: '', Items: [] },
  Recognition: { Title: '', Items: [] },
}

export const EMPTY_PROGRAM_CONTENT_BLOCK: ProgramContentBlock = {
  Title: '',
  Content: '',
}
